import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ListPageContext from '@/context/ListPageContext';
import DownloadContentReportPanel from  '@/components/page/Content/DownloadContentReportPanel/DownloadContentReportPanel';

class DownloadContentReportPortal  extends Component {
    render() {

    // Container ref
    const targetContainer = document.getElementById('react-contentreport-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
        <ListPageContext ><DownloadContentReportPanel /></ListPageContext>, targetContainer
    );
  }
}

export default DownloadContentReportPortal;